/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_jw_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste a JSON Web Token to read its header and payload as formatted JSON. Timestamp claims are shown as readable UTC dates. Decoding happens in your browser.`)
};

const es_jw_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pega un JSON Web Token para leer su encabezado y carga útil como JSON formateado. Las reclamaciones de marca de tiempo se muestran como fechas UTC legibles. La decodificación ocurre en tu navegador.`)
};

const de_jw_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fügen Sie ein JSON Web Token ein, um Header und Payload als formatiertes JSON zu lesen. Zeitstempel-Claims werden als lesbare UTC-Daten angezeigt. Die Dekodierung erfolgt in Ihrem Browser.`)
};

const nl_jw_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plak een JSON Web Token in om de header en payload als opgemaakte JSON te lezen. Timestamp claims worden weergegeven als leesbare UTC-datums. Decodering vindt plaats in uw browser.`)
};

const fr_jw_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collez un jeton JWT pour lire son en-tête et sa charge utile au format JSON. Les revendications d'horodatage s'affichent sous forme de dates UTC lisibles. Le décodage se fait dans votre navigateur.`)
};

const it_jw_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incolla un JSON Web Token per leggere la sua intestazione e payload come JSON formattato. Le rivendicazioni di timestamp vengono visualizzate come date UTC leggibili. La decodifica avviene nel tuo browser.`)
};

const pt_br2_jw_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cole um JSON Web Token para ler seu cabeçalho e payload como JSON formatado. As reivindicações de timestamp são mostradas como datas UTC legíveis. A decodificação ocorre no seu navegador.`)
};

const pt_jw_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cole um JSON Web Token para ler o seu cabeçalho e carga como JSON formatado. As reivindicações de marcação de tempo são apresentadas como datas UTC legíveis. A descodificação ocorre no seu navegador.`)
};

const ja_jw_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON Web Tokenを貼り付けてヘッダーとペイロードをフォーマットされたJSONとして読みます。タイムスタンプクレームは読みやすいUTC日付で表示されます。デコーディングはブラウザで行われます。`)
};

const zh_jw_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`粘贴一个 JSON Web Token，即可以格式化的 JSON 形式读取其头部和载荷。时间戳声明会以可读的 UTC 日期显示。解码过程在你的浏览器中完成。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const jw_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.jw_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("jw_intro", locale)
	if (locale === "en") return en_jw_intro(inputs)
	if (locale === "es") return es_jw_intro(inputs)
	if (locale === "de") return de_jw_intro(inputs)
	if (locale === "nl") return nl_jw_intro(inputs)
	if (locale === "fr") return fr_jw_intro(inputs)
	if (locale === "it") return it_jw_intro(inputs)
	if (locale === "pt-BR") return pt_br2_jw_intro(inputs)
	if (locale === "pt") return pt_jw_intro(inputs)
	if (locale === "ja") return ja_jw_intro(inputs)
	return zh_jw_intro(inputs)
};